<template>
	<div class="grid-flex-container" v-if="currentForm">
		<inventory-toolbar
			:gridViewName="gridViewName"
			:quickFilter="quickFilter"
			:advancedFilter="advancedFilter"
			:visibleColumns="visibleColumns"
			:hiddenColumns="hiddenColumns"
			@quickFilterChanged="onQuickFilterChanged"
			@advancedFilterChanged="onAdvancedFilterChanged"
			@multipleSelectionClick="onMultipleSelectionClick"
			@bulkEdit="bulkEdit"
		/>

		<div class="generic-grid-container">
			<grid-view
				v-if="visibleColumns"
				:gridData="gridData"
				:irisUserMetadata="irisUserMetadata"
				:loadingData="gridLoading"
				:visibleColumns="visibleColumns"
				:sorting="sorting"
				:page="page"
				:rowsPerPage="rowsPerPage"
				:totalCount="totalCount"
				:hasActions="true"
				:selectedRows="selectedRows"
				:multipleSelection="multipleSelection"
				@rowsPerPageChanged="onRowsPerPageChanged"
				@rowSelectionChanged="onRowSelectionChanged"
				@pageChanged="onPageChanged"
				@sortChanged="onSortChanged"
			>
				<template v-slot:[`actionsColumns`]="{ item }">
					<td class="fixed-col">
						<v-btn
							fab
							small
							icon
							elevation="1"
							class="action-btn"
							@click="openItemHistory(item.Id)"
						>
							<v-icon color="info" small>mdi-history</v-icon>
						</v-btn>
						<v-btn
							fab
							small
							icon
							elevation="1"
							class="action-btn"
							@click="editItem(item)"
						>
							<v-icon color="primary" small>mdi-pencil</v-icon>
						</v-btn>
					</td>
				</template>
			</grid-view>
			<bulk-edit-form-modal
				v-if="showBulkEditModal"
				:showDialog="showBulkEditModal"
				:selectedRows="selectedRows"
				@close="onCloseBulkEditModal"
				@save="onSaveBulkEditModal"
			/>
		</div>
	</div>
</template>
<script>
import InventoryToolbar from './InventoryToolbar.vue';
import BulkEditFormModal from '../form/BulkEditFormModal.vue';

import { mapGetters } from 'vuex';
import {
	InventoryFormGridActions,
	InventoryFormFormActions,
} from '../../../store/actions';
import {
	InventoryFormGridGetters,
	AuthGetterTypes,
} from '../../../store/getters';
//

import GridView from '../../shared/gridViews/GridView.vue';

export default {
	name: 'InventoryGrid',
	components: { GridView, InventoryToolbar, BulkEditFormModal },
	data() {
		return {
			selectedRows: [],
			multipleSelection: false,
			showBulkEditModal: false,
		};
	},
	computed: {
		...mapGetters({
			currentUserId: [AuthGetterTypes.CURRENT_USER_ID],
			currentForm: [InventoryFormGridGetters.SELECTED_INVENTORY_FORM],
			gridViewName: [InventoryFormGridGetters.GRID_VIEW_NAME],
			gridLoading: [InventoryFormGridGetters.GRID_LOADING],
			gridData: [InventoryFormGridGetters.GRID_DATA],
			irisUserMetadata: [InventoryFormGridGetters.IRIS_USER_METADATA],
			totalCount: [InventoryFormGridGetters.TOTAL_COUNT],

			visibleColumns: [InventoryFormGridGetters.VISIBLE_COLUMNS],
			hiddenColumns: [InventoryFormGridGetters.HIDDEN_COLUMNS],
			page: [InventoryFormGridGetters.PAGE],
			rowsPerPage: [InventoryFormGridGetters.ROWS_PER_PAGE],
			sorting: [InventoryFormGridGetters.SORTING],

			quickFilter: [InventoryFormGridGetters.QUICK_FILTER],
			advancedFilter: [InventoryFormGridGetters.ADVANCED_FILTER],
		}),
		currentInventoryFormId() {
			return this.$route.params.formId;
		},
	},
	watch: {
		currentInventoryFormId: function () {
			this.loadInventoryForm();
		},
	},

	created() {
		this.loadInventoryForm();
	},
	destroyed() {
		this.$store.dispatch(InventoryFormGridActions.CLEAR);
	},
	methods: {
		onCloseBulkEditModal() {
			this.showBulkEditModal = false;
		},
		onSaveBulkEditModal() {
			this.showBulkEditModal = false;
			this.selectedRows = [];
			this.$store.dispatch(InventoryFormGridActions.LOAD_GRID_DATA);
		},
		bulkEdit() {
			this.showBulkEditModal = true;
		},
		onMultipleSelectionClick(value) {
			this.multipleSelection = value;
		},
		onRowSelectionChanged(rows, selectAll) {
			if (!rows) return;
			rows.forEach((row) => {
				let index = this.selectedRows.indexOf(row);
				if (selectAll === null) {
					//single row click
					if (index >= 0) {
						this.selectedRows.splice(index, 1);
					} else {
						this.selectedRows.push(row);
					}
				} else {
					//select all
					if (selectAll) {
						if (index < 0) this.selectedRows.push(row);
					} else {
						if (index >= 0) this.selectedRows.splice(index, 1);
					}
				}
			});
		},
		loadInventoryForm() {
			this.$store
				.dispatch(InventoryFormGridActions.CLEAR)
				.then(() => {
					return this.$store.dispatch(
						InventoryFormGridActions.LOAD_INVENTORY_FORM,
						this.currentInventoryFormId
					);
				})
				.then(() => {
					this.$store
						.dispatch(
							InventoryFormGridActions.LOAD_DEFAULT_GRID_VIEW_FOR_USER
						)
						.then(() => {});
				});
		},

		onPageChanged(value) {
			this.$store.dispatch(InventoryFormGridActions.UPDATE_PAGE, value);
		},
		onRowsPerPageChanged(value) {
			this.$store.dispatch(
				InventoryFormGridActions.UPDATE_ROWS_PER_PAGE,
				value
			);
		},
		onSortChanged(value) {
			this.$store.dispatch(
				InventoryFormGridActions.UPDATE_SORTING,
				value
			);
		},
		onQuickFilterChanged(value) {
			this.$store.dispatch(
				InventoryFormGridActions.UPDATE_QUICK_FILTER,
				value
			);
		},
		onAdvancedFilterChanged(value) {
			this.$store.dispatch(
				InventoryFormGridActions.UPDATE_ADVANCED_FILTER,
				value
			);
		},
		editItem(record) {
			this.$store
				.dispatch(InventoryFormFormActions.LOAD_GRID_RECORD, {
					record: record,
					userId: this.currentUserId,
				})
				.then(() => {
					this.$router.push({ name: 'InventoryForm' });
				});
		},
		openItemHistory(val) {
			this.$router.push({
				name: 'InventoryFormHistory',
				params: { recordId: val },
			});
		},
	},
};
</script>
